import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import FieldForm from './FieldForm';
import Swal from 'sweetalert2';
import showAlert from '../../../common/utils/alert';

export class FieldDetail extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    field: PropTypes.object.isRequired,
    collectionOptions: PropTypes.func.isRequired,
    projectCollections: PropTypes.array.isRequired,
  };

  handleSubmit = (values) => {
    values = { ...this.props.field, ...values };
    const { version, projectId, collection, actions } = this.props;
    actions.editField({
      projectId,
      collectionName: collection.collectionName,
      data: values,
      version,
    });
  };

  deleteField = () => {
    const { actions, field, projectId, collection, version } = this.props;
    const preConfirm = () => {
      actions.deleteField({
        fieldId: field._id,
        projectId: projectId,
        version,
        collectionName: collection.collectionName,
      });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };
  showRefCollectionDetail = (refCollection) => {
    if (!refCollection) {
      return refCollection;
    }
    const {
      collectionName,
      collectionField,
      isShowAsText,
      isShowAsRadioOrCheckBox,
      displayType,
      parentCollectionField,
      isFileType,
    } = refCollection;
    const display = isShowAsText
      ? 'asText'
      : isShowAsRadioOrCheckBox
      ? 'asRadioOrCheckbox'
      : displayType;
    return {
      collectionName,
      collectionField,
      displayType: display,
      parentCollectionField,
      isShowAsText,
      isFileType,
    };
  };

  showValidationDetail = (validation) => {
    if (!validation) {
      return validation;
    }
    const { allowedFileTypes, noAllowedFiles } = validation;
    return {
      min: null,
      max: null,
      regex: '',
      allowedFileTypes,
      noAllowedFiles,
    };
  };
  createSchemaForFields = () => {
    const {
      fieldTitle,
      type,
      placeholder,
      validation,
      required,
      refCollection,
      staticOptions,
      unique,
      isMultiSelect,
      extraFieldSetting,
      encrypted,
      isPrivate,
      isGenerateIcons,
      isGenerateURL,
    } = this.props.field;
    return {
      fieldTitle: fieldTitle,
      type: type,
      placeholder: placeholder,
      validation: this.showValidationDetail(validation),
      required: required,
      refCollection: this.showRefCollectionDetail(refCollection),
      staticOptions: staticOptions,
      unique: unique,
      encrypted: encrypted,
      isMultiSelect: isMultiSelect,
      extraFieldSetting: extraFieldSetting,
      isPrivate: isPrivate,
      isGenerateIcons: isGenerateIcons,
      isGenerateURL: isGenerateURL,
    };
  };

  render() {
    const {
      collectionOptions,
      projectCollections,
      field,
      showCollectionFieldDeleteLoader,
      projectDetail,
      collection,
      fieldFlag,
    } = this.props;
    const { fieldTitle, type, isMultiSelect, isPluginField, fieldName } = field;
    const { restrictEdit } = collection;
    return (
      <FieldForm
        title={fieldTitle.en}
        fieldName={fieldName}
        type={type}
        isMultiSelect={isMultiSelect}
        createSchemaForFields={this.createSchemaForFields}
        collectionOptions={collectionOptions}
        handleSubmit={this.handleSubmit}
        projectCollections={projectCollections}
        isUpdate={true}
        deleteField={this.deleteField}
        showCollectionFieldDeleteLoader={showCollectionFieldDeleteLoader}
        isPluginField={isPluginField}
        projectDetail={projectDetail}
        restrictEdit={restrictEdit}
        fieldFlag={fieldFlag}
      />
    );
  }
}
